import { render } from "./rightItemCard.vue?vue&type=template&id=fa776cde"
import script from "./rightItemCard.vue?vue&type=script&lang=js"
export * from "./rightItemCard.vue?vue&type=script&lang=js"

import "./rightItemCard.vue?vue&type=style&index=0&id=fa776cde&lang=less"

import exportComponent from "D:\\project\\Mase_Customer\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__